module.exports = __webpack_public_path__ + "img/fcfm-2.6dc39922.jpg";